var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332.241,
    height: 135.34,
    viewBox: "0 0 332.241 135.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3093",
    "data-name": "Group 3093",
    transform: "translate(-108.688 -43.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3095",
    "data-name": "Group 3095",
    transform: "translate(109.438 131.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M212.228,114.6h10.36v-2.108h15.076V114.6h9.594v-2.108h14.858l-.084,2.108h10.556v44.509l-60.36-.121Z",
    transform: "translate(-212.228 -112.489)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3048",
    "data-name": "Group 3048",
    transform: "translate(36.634 6.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037",
    "data-name": "Group 3037",
    transform: "translate(9.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3038",
    "data-name": "Group 3038",
    transform: "translate(0 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3039",
    "data-name": "Group 3039",
    transform: "translate(9.002 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3040",
    "data-name": "Group 3040",
    transform: "translate(0 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3041",
    "data-name": "Group 3041",
    transform: "translate(9.002 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3042",
    "data-name": "Group 3042",
    transform: "translate(0 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3043",
    "data-name": "Group 3043",
    transform: "translate(9.002 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3044",
    "data-name": "Group 3044",
    transform: "translate(0 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045",
    transform: "translate(9.002 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3046",
    "data-name": "Group 3046",
    transform: "translate(0 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047",
    transform: "translate(9.002 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3096",
    "data-name": "Group 3096",
    transform: "translate(12.58 6.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3036-2",
    "data-name": "Group 3036"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166-2",
    "data-name": "Rectangle 166",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037-2",
    "data-name": "Group 3037",
    transform: "translate(9.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167-2",
    "data-name": "Rectangle 167",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3038-2",
    "data-name": "Group 3038",
    transform: "translate(0 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168-2",
    "data-name": "Rectangle 168",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3039-2",
    "data-name": "Group 3039",
    transform: "translate(9.002 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169-2",
    "data-name": "Rectangle 169",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3040-2",
    "data-name": "Group 3040",
    transform: "translate(0 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170-2",
    "data-name": "Rectangle 170",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3041-2",
    "data-name": "Group 3041",
    transform: "translate(9.002 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171-2",
    "data-name": "Rectangle 171",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3042-2",
    "data-name": "Group 3042",
    transform: "translate(0 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172-2",
    "data-name": "Rectangle 172",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3043-2",
    "data-name": "Group 3043",
    transform: "translate(9.002 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173-2",
    "data-name": "Rectangle 173",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3044-2",
    "data-name": "Group 3044",
    transform: "translate(0 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174-2",
    "data-name": "Rectangle 174",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045-2",
    "data-name": "Group 3045",
    transform: "translate(9.002 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175-2",
    "data-name": "Rectangle 175",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3046-2",
    "data-name": "Group 3046",
    transform: "translate(0 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176-2",
    "data-name": "Rectangle 176",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3047-2",
    "data-name": "Group 3047",
    transform: "translate(9.002 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177-2",
    "data-name": "Rectangle 177",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2911",
    "data-name": "Group 2911",
    transform: "translate(301.367 86.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M209.415,85.652h-4.871V82.495H187.089v3.157h-4.942v87.542h27.269Z",
    transform: "translate(-182.146 -82.495)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2910",
    "data-name": "Group 2910",
    transform: "translate(6.65 6.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2908",
    "data-name": "Group 2908",
    transform: "translate(8.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M194.206,87.1h-1.462v63.519h1.462V87.1Z",
    transform: "translate(-192.744 -87.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 0.119,
    height: 62.177,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2906",
    "data-name": "Group 2906"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 0.12,
    height: 62.177,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M188.311,87.1h-1.462v63.519h1.462V87.1Z",
    transform: "translate(-186.848 -87.096)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2907",
    "data-name": "Group 2907",
    transform: "translate(4.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 0.12,
    height: 62.177,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M191.258,87.1H189.8v63.519h1.462V87.1Z",
    transform: "translate(-189.796 -87.096)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2909",
    "data-name": "Group 2909",
    transform: "translate(12.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 0.12,
    height: 62.177,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M197.154,87.1h-1.462v63.519h1.462V87.1Z",
    transform: "translate(-195.691 -87.096)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M245.105,99.462l-15.647-7.851-3.023-1.517v84.385H247.9V100.864Z",
    transform: "translate(138.157 -15.137)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2931",
    "data-name": "Group 2931",
    transform: "translate(231.369 127.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M151.2,109.542H133.607l-.445,50.3h22.863l.177-20.007.268-30.3Z",
    transform: "translate(-133.162 -109.542)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2930",
    "data-name": "Group 2930",
    transform: "translate(5.715 5.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2912",
    "data-name": "Group 2912"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M139.711,113.616H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -113.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2913",
    "data-name": "Group 2913",
    transform: "translate(4.908)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M143.181,113.616h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -113.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2914",
    "data-name": "Group 2914",
    transform: "translate(9.815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M146.651,113.616h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -113.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2915",
    "data-name": "Group 2915",
    transform: "translate(0 4.955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M139.711,117.12H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -117.12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2916",
    "data-name": "Group 2916",
    transform: "translate(4.908 4.955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M143.181,117.12h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -117.12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2917",
    "data-name": "Group 2917",
    transform: "translate(9.815 4.955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M146.651,117.12h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -117.12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2918",
    "data-name": "Group 2918",
    transform: "translate(0 9.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M139.711,120.623H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -120.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2919",
    "data-name": "Group 2919",
    transform: "translate(4.908 9.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M143.181,120.623h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -120.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2920",
    "data-name": "Group 2920",
    transform: "translate(9.815 9.909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M146.651,120.623h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -120.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2921",
    "data-name": "Group 2921",
    transform: "translate(0 14.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.711,124.126H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -124.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2922",
    "data-name": "Group 2922",
    transform: "translate(4.908 14.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M143.181,124.126h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -124.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2923",
    "data-name": "Group 2923",
    transform: "translate(9.815 14.864)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M146.651,124.126h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -124.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2924",
    "data-name": "Group 2924",
    transform: "translate(0 19.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.711,127.629H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -127.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2925",
    "data-name": "Group 2925",
    transform: "translate(4.908 19.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M143.181,127.629h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -127.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2926",
    "data-name": "Group 2926",
    transform: "translate(9.815 19.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M146.651,127.629h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -127.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2927",
    "data-name": "Group 2927",
    transform: "translate(0 24.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 1.095,
    height: 1.289,
    transform: "translate(0.706 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M139.711,131.132H137.2v2.7h2.508v-2.7Z",
    transform: "translate(-137.202 -131.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2928",
    "data-name": "Group 2928",
    transform: "translate(4.908 24.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M143.181,131.132h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-140.673 -131.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2929",
    "data-name": "Group 2929",
    transform: "translate(9.815 24.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 1.094,
    height: 1.289,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M146.651,131.132h-2.508v2.7h2.508v-2.7Z",
    transform: "translate(-144.143 -131.132)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2933",
    "data-name": "Group 2933",
    transform: "translate(179.237 116.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M118.664,109.585v-4.779h-4.8v-3.042l-14.315,3.042v4.779H96.664v53.284h24.885V109.585Z",
    transform: "translate(-96.664 -101.765)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2932",
    "data-name": "Group 2932",
    transform: "translate(5.387 10.419)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 14.11,
    height: 2.201,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 5.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 11.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 17.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 23.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 28.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 34.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 14.11,
    height: 2.201,
    transform: "translate(0 40.489)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2939",
    "data-name": "Group 2939",
    transform: "translate(396.072 44.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M274.851,78.785V71.941H251.8v6.843h-3.48V205.4h30.015V78.785Z",
    transform: "translate(-248.316 -71.941)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2938",
    "data-name": "Group 2938",
    transform: "translate(6.37 5.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2934",
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 0.64,
    height: 68.221,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M254.8,75.84H252.82V145.4H254.8V75.84Z",
    transform: "translate(-252.82 -75.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2935",
    "data-name": "Group 2935",
    transform: "translate(5.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 0.64,
    height: 68.221,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M258.407,75.84h-1.982V145.4h1.982V75.84Z",
    transform: "translate(-256.424 -75.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2936",
    "data-name": "Group 2936",
    transform: "translate(10.195)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 0.641,
    height: 68.221,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M262.011,75.84h-1.982V145.4h1.982V75.84Z",
    transform: "translate(-260.029 -75.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2937",
    "data-name": "Group 2937",
    transform: "translate(15.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 0.641,
    height: 68.221,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M265.616,75.84h-1.982V145.4h1.982V75.84Z",
    transform: "translate(-263.633 -75.84)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971",
    transform: "translate(405.93 108.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M255.895,103.474l-.608,70.094h25.859l.608-70.094Z",
    transform: "translate(-255.287 -103.474)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2970",
    "data-name": "Group 2970",
    transform: "translate(7.181 4.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2940",
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M260.845,107.007H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2941",
    "data-name": "Group 2941",
    transform: "translate(5.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M264.551,107.007H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2942",
    "data-name": "Group 2942",
    transform: "translate(10.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M268.257,107.007H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2943",
    "data-name": "Group 2943",
    transform: "translate(0 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M260.845,110.328H258.49V112.9h2.355v-2.576Z",
    transform: "translate(-258.49 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2944",
    "data-name": "Group 2944",
    transform: "translate(5.241 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M264.551,110.328H262.2V112.9h2.355v-2.576Z",
    transform: "translate(-262.196 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2945",
    "data-name": "Group 2945",
    transform: "translate(10.483 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M268.257,110.328H265.9V112.9h2.355v-2.576Z",
    transform: "translate(-265.902 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2946",
    "data-name": "Group 2946",
    transform: "translate(0 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M260.845,113.649H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2947",
    "data-name": "Group 2947",
    transform: "translate(5.241 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M264.551,113.649H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2948",
    "data-name": "Group 2948",
    transform: "translate(10.483 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M268.257,113.649H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2949",
    "data-name": "Group 2949",
    transform: "translate(0 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M260.845,116.97H258.49v2.576h2.355V116.97Z",
    transform: "translate(-258.49 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2950",
    "data-name": "Group 2950",
    transform: "translate(5.241 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M264.551,116.97H262.2v2.576h2.355V116.97Z",
    transform: "translate(-262.196 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2951",
    "data-name": "Group 2951",
    transform: "translate(10.483 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M268.257,116.97H265.9v2.576h2.355V116.97Z",
    transform: "translate(-265.902 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2952",
    "data-name": "Group 2952",
    transform: "translate(0 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M260.845,120.291H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2953",
    "data-name": "Group 2953",
    transform: "translate(5.241 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M264.551,120.291H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2954",
    "data-name": "Group 2954",
    transform: "translate(10.483 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M268.257,120.291H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2955",
    "data-name": "Group 2955",
    transform: "translate(0 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M260.845,123.612H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2956",
    "data-name": "Group 2956",
    transform: "translate(5.241 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M264.551,123.612H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2957",
    "data-name": "Group 2957",
    transform: "translate(10.483 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M268.257,123.612H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2958",
    "data-name": "Group 2958",
    transform: "translate(0 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M260.845,126.933H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2959",
    "data-name": "Group 2959",
    transform: "translate(5.241 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M264.551,126.933H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2960",
    "data-name": "Group 2960",
    transform: "translate(10.483 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M268.257,126.933H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2961",
    "data-name": "Group 2961",
    transform: "translate(0 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M260.845,130.254H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2962",
    "data-name": "Group 2962",
    transform: "translate(5.241 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M264.551,130.254H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2963",
    "data-name": "Group 2963",
    transform: "translate(10.483 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M268.257,130.254H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2964",
    "data-name": "Group 2964",
    transform: "translate(0 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M260.845,133.576H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965",
    transform: "translate(5.241 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M264.551,133.576H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2966",
    "data-name": "Group 2966",
    transform: "translate(10.483 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M268.257,133.576H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2967",
    "data-name": "Group 2967",
    transform: "translate(0 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M260.845,136.9H258.49v2.576h2.355V136.9Z",
    transform: "translate(-258.49 -136.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2968",
    "data-name": "Group 2968",
    transform: "translate(5.241 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M264.551,136.9H262.2v2.576h2.355V136.9Z",
    transform: "translate(-262.196 -136.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2969",
    "data-name": "Group 2969",
    transform: "translate(10.483 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M268.257,136.9H265.9v2.576h2.355V136.9Z",
    transform: "translate(-265.902 -136.897)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2987",
    "data-name": "Group 2987",
    transform: "translate(334.85 92.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2986",
    "data-name": "Group 2986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M219.215,160.712H205.609V85.047l13.605,1.278Z",
    transform: "translate(-205.609 -85.047)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2978",
    "data-name": "Group 2978",
    transform: "translate(2.428 5.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M216.416,88.775h-9.09v1.938h9.09V88.775Z",
    transform: "translate(-207.326 -88.775)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    transform: "translate(0 4.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 7.675,
    height: 0.524,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M216.416,92.178h-9.09v1.938h9.09V92.178Z",
    transform: "translate(-207.326 -92.178)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974",
    transform: "translate(0 9.626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M216.416,95.581h-9.09v1.938h9.09V95.581Z",
    transform: "translate(-207.326 -95.581)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2975",
    "data-name": "Group 2975",
    transform: "translate(0 14.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 7.675,
    height: 0.524,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M216.416,98.984h-9.09v1.938h9.09V98.984Z",
    transform: "translate(-207.326 -98.984)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2976",
    "data-name": "Group 2976",
    transform: "translate(0 19.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M216.416,102.387h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -102.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2977",
    "data-name": "Group 2977",
    transform: "translate(0 24.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M216.416,105.791h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -105.791)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    transform: "translate(2.428 33.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2979",
    "data-name": "Group 2979"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M216.416,108.966h-9.09V110.9h9.09v-1.938Z",
    transform: "translate(-207.326 -108.966)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2980",
    "data-name": "Group 2980",
    transform: "translate(0 4.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 7.675,
    height: 0.524,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M216.416,112.369h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -112.369)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981",
    transform: "translate(0 9.626)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M216.416,115.772h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -115.772)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982",
    transform: "translate(0 14.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M216.416,119.175h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -119.175)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983",
    transform: "translate(0 19.252)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 7.675,
    height: 0.523,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M216.416,122.579h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -122.579)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    transform: "translate(0 24.065)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 7.675,
    height: 0.524,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M216.416,125.982h-9.09v1.938h9.09v-1.938Z",
    transform: "translate(-207.326 -125.982)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M212.47,156.348h12.506V95.581l-12.506,1.18Z",
    transform: "translate(-202.767 -80.683)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3004",
    "data-name": "Group 3004",
    transform: "translate(257.361 117.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988",
    transform: "translate(0 -16.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M186.733,106.438v-4.051H157.421v4.051h-5.4l-.723,73.026H190.92l.723-73.026Z",
    transform: "translate(-151.297 -102.387)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3003",
    "data-name": "Group 3003",
    transform: "translate(6.159 -4.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 12.114,
    height: 0.764,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M169.11,109.322H155.652v2.107H169.11v-2.107Z",
    transform: "translate(-155.652 -109.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2990",
    "data-name": "Group 2990",
    transform: "translate(15.688 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 12.125,
    height: 0.764,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M180.211,109.322H166.745v2.107h13.467v-2.107Z",
    transform: "translate(-166.745 -109.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991",
    transform: "translate(0 5.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 12.114,
    height: 0.765,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M169.11,113.241H155.652v2.107H169.11v-2.107Z",
    transform: "translate(-155.652 -113.241)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992",
    transform: "translate(15.688 5.542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 12.125,
    height: 0.765,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M180.211,113.241H166.745v2.107h13.467v-2.107Z",
    transform: "translate(-166.745 -113.241)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993",
    transform: "translate(0 11.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 12.114,
    height: 0.774,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M169.11,117.153H155.652v2.116H169.11v-2.116Z",
    transform: "translate(-155.652 -117.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994",
    transform: "translate(15.688 11.075)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 12.125,
    height: 0.774,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M180.211,117.153H166.745v2.116h13.467v-2.116Z",
    transform: "translate(-166.745 -117.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995",
    transform: "translate(0 16.617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 12.114,
    height: 0.764,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M169.11,121.072H155.652v2.107H169.11v-2.107Z",
    transform: "translate(-155.652 -121.072)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2996",
    "data-name": "Group 2996",
    transform: "translate(15.688 16.617)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 12.125,
    height: 0.764,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M180.211,121.072H166.745v2.107h13.467v-2.107Z",
    transform: "translate(-166.745 -121.072)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2997",
    "data-name": "Group 2997",
    transform: "translate(0 22.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 12.114,
    height: 0.765,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M169.11,124.991H155.652V127.1H169.11v-2.107Z",
    transform: "translate(-155.652 -124.991)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    transform: "translate(15.688 22.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 12.125,
    height: 0.765,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M180.211,124.991H166.745V127.1h13.467v-2.107Z",
    transform: "translate(-166.745 -124.991)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2999",
    "data-name": "Group 2999",
    transform: "translate(0 27.702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 12.114,
    height: 0.764,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M169.11,128.91H155.652v2.107H169.11V128.91Z",
    transform: "translate(-155.652 -128.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000",
    transform: "translate(15.688 27.702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 12.125,
    height: 0.764,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M180.211,128.91H166.745v2.107h13.467V128.91Z",
    transform: "translate(-166.745 -128.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001",
    transform: "translate(0 33.234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 12.114,
    height: 0.774,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M169.11,132.821H155.652v2.116H169.11v-2.116Z",
    transform: "translate(-155.652 -132.821)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3002",
    "data-name": "Group 3002",
    transform: "translate(15.688 33.234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 12.125,
    height: 0.774,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M180.211,132.821H166.745v2.116h13.467v-2.116Z",
    transform: "translate(-166.745 -132.821)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3028",
    "data-name": "Group 3028",
    transform: "translate(418.967 138.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M285.716,117.381H264.5v4.04h1.347v35.649h18.855V121.421h1.01Z",
    transform: "translate(-264.505 -117.381)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3027",
    "data-name": "Group 3027",
    transform: "translate(5.345 6.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3009",
    "data-name": "Group 3009"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M270.549,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-268.284 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3010",
    "data-name": "Group 3010",
    transform: "translate(4.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M273.682,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-271.417 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3011",
    "data-name": "Group 3011",
    transform: "translate(8.863)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M276.815,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-274.551 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3012",
    "data-name": "Group 3012",
    transform: "translate(0 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M270.549,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3013",
    "data-name": "Group 3013",
    transform: "translate(4.431 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M273.682,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3014",
    "data-name": "Group 3014",
    transform: "translate(8.863 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M276.815,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3015",
    "data-name": "Group 3015",
    transform: "translate(0 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M270.549,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-268.284 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3016",
    "data-name": "Group 3016",
    transform: "translate(4.431 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M273.682,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-271.417 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(8.863 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M276.815,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-274.551 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3018",
    "data-name": "Group 3018",
    transform: "translate(0 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M270.549,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3019",
    "data-name": "Group 3019",
    transform: "translate(4.431 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M273.682,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3020",
    "data-name": "Group 3020",
    transform: "translate(8.863 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M276.815,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3021",
    "data-name": "Group 3021",
    transform: "translate(0 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M270.549,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-268.284 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3022",
    "data-name": "Group 3022",
    transform: "translate(4.431 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M273.682,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-271.417 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3023",
    "data-name": "Group 3023",
    transform: "translate(8.863 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M276.815,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-274.551 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3024",
    "data-name": "Group 3024",
    transform: "translate(0 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M270.549,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -136.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3025",
    "data-name": "Group 3025",
    transform: "translate(4.431 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M273.682,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -136.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3026",
    "data-name": "Group 3026",
    transform: "translate(8.863 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M276.815,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -136.315)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3049",
    "data-name": "Group 3049",
    transform: "translate(345.033 131.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323-2",
    "data-name": "Path 323",
    d: "M212.228,114.6H221.7v-2.108h13.79V114.6h8.776v-2.108h13.591l-.077,2.108h9.656v44.509l-55.213-.121Z",
    transform: "translate(-212.228 -112.489)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3035",
    "data-name": "Group 3035",
    transform: "translate(10.32 6.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3029",
    "data-name": "Group 3029"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030",
    transform: "translate(9.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    transform: "translate(0 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3032",
    "data-name": "Group 3032",
    transform: "translate(9.002 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033",
    transform: "translate(0 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3034",
    "data-name": "Group 3034",
    transform: "translate(9.002 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3048-2",
    "data-name": "Group 3048",
    transform: "translate(32.714 6.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3036-3",
    "data-name": "Group 3036"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166-3",
    "data-name": "Rectangle 166",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037-3",
    "data-name": "Group 3037",
    transform: "translate(9.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167-3",
    "data-name": "Rectangle 167",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3038-3",
    "data-name": "Group 3038",
    transform: "translate(0 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168-3",
    "data-name": "Rectangle 168",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3039-3",
    "data-name": "Group 3039",
    transform: "translate(9.002 6.52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169-3",
    "data-name": "Rectangle 169",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3040-3",
    "data-name": "Group 3040",
    transform: "translate(0 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170-3",
    "data-name": "Rectangle 170",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3041-3",
    "data-name": "Group 3041",
    transform: "translate(9.002 13.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171-3",
    "data-name": "Rectangle 171",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3042-3",
    "data-name": "Group 3042",
    transform: "translate(0 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172-3",
    "data-name": "Rectangle 172",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3043-3",
    "data-name": "Group 3043",
    transform: "translate(9.002 19.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173-3",
    "data-name": "Rectangle 173",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3044-3",
    "data-name": "Group 3044",
    transform: "translate(0 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174-3",
    "data-name": "Rectangle 174",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045-3",
    "data-name": "Group 3045",
    transform: "translate(9.002 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175-3",
    "data-name": "Rectangle 175",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3046-3",
    "data-name": "Group 3046",
    transform: "translate(0 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176-3",
    "data-name": "Rectangle 176",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3047-3",
    "data-name": "Group 3047",
    transform: "translate(9.002 32.597)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177-3",
    "data-name": "Rectangle 177",
    width: 3.258,
    height: 2.215,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060",
    transform: "translate(263.667 160.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M155.652,132.98v3.6h2.809v13.456h48.3V136.58h2.808v-3.6Z",
    transform: "translate(-155.652 -132.98)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3053",
    "data-name": "Group 3053",
    transform: "translate(9.294 8.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3051",
    "data-name": "Group 3051"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 2.994,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3052",
    "data-name": "Group 3052",
    transform: "translate(5.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 2.99,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056",
    transform: "translate(36.52 8.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3054",
    "data-name": "Group 3054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 2.994,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3055",
    "data-name": "Group 3055",
    transform: "translate(5.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2.99,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059",
    transform: "translate(22.96 8.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 2.945,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    transform: "translate(5.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 2.939,
    height: 5.545,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3069",
    "data-name": "Group 3069",
    transform: "translate(324.764 152.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M198.407,127.013v4.334h1.445v21.68h45.857v-21.68h1.379v-4.334Z",
    transform: "translate(-198.407 -127.013)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3068",
    "data-name": "Group 3068",
    transform: "translate(6.634 7.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3067",
    "data-name": "Group 3067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    "data-name": "Group 3062",
    transform: "translate(6.524)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3063",
    "data-name": "Group 3063",
    transform: "translate(26.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064",
    transform: "translate(13.049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065",
    transform: "translate(19.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066",
    transform: "translate(32.622)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 2.791,
    height: 2.791,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 5.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 2.791,
    height: 2.791,
    transform: "translate(0 10.23)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3073",
    "data-name": "Group 3073",
    transform: "translate(192.356 141.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M145.475,122.275v-2.421H133.268v2.421h-7.927v-2.421H112.885v2.421H105.8V155.69l47.053.109V122.275Z",
    transform: "translate(-105.802 -119.853)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3072",
    "data-name": "Group 3072",
    transform: "translate(7.239 6.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 4.156,
    height: 3.213,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 5.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 5.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 11.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 11.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 17.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 17.666)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3071",
    "data-name": "Group 3071",
    transform: "translate(20.227)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 4.156,
    height: 3.213,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 5.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 5.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 11.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 11.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 4.156,
    height: 3.213,
    transform: "translate(0 17.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 4.156,
    height: 3.213,
    transform: "translate(8.131 17.666)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M206.632,145.915c0-.023.007-.044.007-.066A1.849,1.849,0,0,0,204.79,144c-.033,0-.062.008-.095.01a2.929,2.929,0,0,0-3.836-1.717,2.928,2.928,0,0,0-2.085-.881,2.993,2.993,0,0,0-2.806,2.052h-.017a1.888,1.888,0,0,0-1.83,2.452Z",
    transform: "translate(124.219 31.024)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 0.949
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074",
    transform: "translate(175.475 160.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M108.475,140.1a3.714,3.714,0,0,0-2.134-3.362,5.174,5.174,0,0,0-10.07-.064,3.647,3.647,0,0,0-2.225,3.373c-.018,3.4,3.162,5.371,7.114,5.38C105.315,145.437,108.467,143.6,108.475,140.1Z",
    transform: "translate(-94.046 -132.726)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 12.095,
    transform: "translate(7.231 5.591)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 2.898,
    y2: 1.683,
    transform: "translate(4.146 9.228)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 2.15,
    x2: 2.618,
    transform: "translate(7.512 7.027)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3075",
    "data-name": "Group 3075",
    transform: "translate(232.005 159.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M148.058,139.467a3.715,3.715,0,0,0-2.133-3.363,5.176,5.176,0,0,0-10.071-.064,3.648,3.648,0,0,0-2.223,3.373c-.018,3.4,3.162,5.371,7.114,5.38C144.9,144.8,148.051,142.962,148.058,139.467Z",
    transform: "translate(-133.631 -132.092)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 12.095,
    transform: "translate(7.231 5.59)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 2.898,
    y2: 1.683,
    transform: "translate(4.145 9.228)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 2.15,
    x2: 2.618,
    transform: "translate(7.511 7.026)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    transform: "translate(249.972 165.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M155.887,141.486a2.483,2.483,0,0,0-1.428-2.25,3.464,3.464,0,0,0-6.742-.044,2.445,2.445,0,0,0-1.489,2.259c-.013,2.277,2.117,3.6,4.763,3.6C153.771,145.059,155.882,143.827,155.887,141.486Z",
    transform: "translate(-146.227 -136.549)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 8.097,
    transform: "translate(4.841 3.284)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 1.94,
    y2: 1.127,
    transform: "translate(2.776 5.719)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y1: 1.44,
    x2: 1.753,
    transform: "translate(5.029 4.245)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M272.115,146.272c0-.023.006-.656.006-.679a1.818,1.818,0,0,0-1.817-1.817c-.031,0-.061.008-.092.01a2.879,2.879,0,0,0-3.772-1.689,2.883,2.883,0,0,0-2.051-.866,2.94,2.94,0,0,0-2.758,2.018l-.018,0a1.885,1.885,0,0,0-1.884,1.884,8.634,8.634,0,0,0,.085,1.141Z",
    transform: "translate(152.484 30.949)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M122.155,146.5c0-.033.01-.064.01-.1a2.664,2.664,0,0,0-2.664-2.665c-.047,0-.091.011-.136.014a4.217,4.217,0,0,0-5.528-2.475,4.223,4.223,0,0,0-3.007-1.27,4.312,4.312,0,0,0-4.043,2.959l-.027,0a2.721,2.721,0,0,0-2.636,3.536Z",
    transform: "translate(85.698 30.441)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077",
    transform: "translate(395.723 153.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M256.505,140.07c0,3.383-1.889,5.728-4.219,5.728s-4.217-2.345-4.217-5.728,1.888-11.8,4.217-11.8S256.505,136.687,256.505,140.07Z",
    transform: "translate(-248.069 -128.269)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 15.813,
    transform: "translate(4.19 7.279)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078",
    transform: "translate(406.048 158.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M261.976,140.882c0,2.649-1.479,4.485-3.3,4.485s-3.3-1.836-3.3-4.485,1.479-9.242,3.3-9.242S261.976,138.233,261.976,140.882Z",
    transform: "translate(-255.37 -131.64)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y2: 12.623,
    transform: "translate(3.281 5.7)",
    fill: "#fff",
    stroke: "#5c667f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3093-2",
    "data-name": "Group 3093",
    transform: "translate(140.45 118.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243-2",
    "data-name": "Path 243",
    d: "M255.779,103.474l-.492,59.358H276.23l.492-59.358Z",
    transform: "translate(-255.287 -103.474)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2970-2",
    "data-name": "Group 2970",
    transform: "translate(4.531 4.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2940-2",
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-2",
    "data-name": "Rectangle 84",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244-2",
    "data-name": "Path 244",
    d: "M260.845,107.007H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2941-2",
    "data-name": "Group 2941",
    transform: "translate(5.241)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85-2",
    "data-name": "Rectangle 85",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245-2",
    "data-name": "Path 245",
    d: "M264.551,107.007H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2942-2",
    "data-name": "Group 2942",
    transform: "translate(10.483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86-2",
    "data-name": "Rectangle 86",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246-2",
    "data-name": "Path 246",
    d: "M268.257,107.007H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -107.007)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2943-2",
    "data-name": "Group 2943",
    transform: "translate(0 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87-2",
    "data-name": "Rectangle 87",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247-2",
    "data-name": "Path 247",
    d: "M260.845,110.328H258.49V112.9h2.355v-2.576Z",
    transform: "translate(-258.49 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2944-2",
    "data-name": "Group 2944",
    transform: "translate(5.241 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88-2",
    "data-name": "Rectangle 88",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248-2",
    "data-name": "Path 248",
    d: "M264.551,110.328H262.2V112.9h2.355v-2.576Z",
    transform: "translate(-262.196 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2945-2",
    "data-name": "Group 2945",
    transform: "translate(10.483 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89-2",
    "data-name": "Rectangle 89",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249-2",
    "data-name": "Path 249",
    d: "M268.257,110.328H265.9V112.9h2.355v-2.576Z",
    transform: "translate(-265.902 -110.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2946-2",
    "data-name": "Group 2946",
    transform: "translate(0 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90-2",
    "data-name": "Rectangle 90",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250-2",
    "data-name": "Path 250",
    d: "M260.845,113.649H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2947-2",
    "data-name": "Group 2947",
    transform: "translate(5.241 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91-2",
    "data-name": "Rectangle 91",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251-2",
    "data-name": "Path 251",
    d: "M264.551,113.649H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2948-2",
    "data-name": "Group 2948",
    transform: "translate(10.483 9.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92-2",
    "data-name": "Rectangle 92",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252-2",
    "data-name": "Path 252",
    d: "M268.257,113.649H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -113.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2949-2",
    "data-name": "Group 2949",
    transform: "translate(0 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93-2",
    "data-name": "Rectangle 93",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253-2",
    "data-name": "Path 253",
    d: "M260.845,116.97H258.49v2.576h2.355V116.97Z",
    transform: "translate(-258.49 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2950-2",
    "data-name": "Group 2950",
    transform: "translate(5.241 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94-2",
    "data-name": "Rectangle 94",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254-2",
    "data-name": "Path 254",
    d: "M264.551,116.97H262.2v2.576h2.355V116.97Z",
    transform: "translate(-262.196 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2951-2",
    "data-name": "Group 2951",
    transform: "translate(10.483 14.091)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95-2",
    "data-name": "Rectangle 95",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255-2",
    "data-name": "Path 255",
    d: "M268.257,116.97H265.9v2.576h2.355V116.97Z",
    transform: "translate(-265.902 -116.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2952-2",
    "data-name": "Group 2952",
    transform: "translate(0 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96-2",
    "data-name": "Rectangle 96",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256-2",
    "data-name": "Path 256",
    d: "M260.845,120.291H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2953-2",
    "data-name": "Group 2953",
    transform: "translate(5.241 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97-2",
    "data-name": "Rectangle 97",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257-2",
    "data-name": "Path 257",
    d: "M264.551,120.291H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2954-2",
    "data-name": "Group 2954",
    transform: "translate(10.483 18.788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98-2",
    "data-name": "Rectangle 98",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258-2",
    "data-name": "Path 258",
    d: "M268.257,120.291H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -120.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2955-2",
    "data-name": "Group 2955",
    transform: "translate(0 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-2",
    "data-name": "Rectangle 99",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259-2",
    "data-name": "Path 259",
    d: "M260.845,123.612H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2956-2",
    "data-name": "Group 2956",
    transform: "translate(5.241 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-2",
    "data-name": "Rectangle 100",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260-2",
    "data-name": "Path 260",
    d: "M264.551,123.612H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2957-2",
    "data-name": "Group 2957",
    transform: "translate(10.483 23.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-2",
    "data-name": "Rectangle 101",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261-2",
    "data-name": "Path 261",
    d: "M268.257,123.612H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -123.612)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2958-2",
    "data-name": "Group 2958",
    transform: "translate(0 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102-2",
    "data-name": "Rectangle 102",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262-2",
    "data-name": "Path 262",
    d: "M260.845,126.933H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2959-2",
    "data-name": "Group 2959",
    transform: "translate(5.241 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103-2",
    "data-name": "Rectangle 103",
    width: 0.94,
    height: 1.161,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263-2",
    "data-name": "Path 263",
    d: "M264.551,126.933H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2960-2",
    "data-name": "Group 2960",
    transform: "translate(10.483 28.181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104-2",
    "data-name": "Rectangle 104",
    width: 0.941,
    height: 1.161,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264-2",
    "data-name": "Path 264",
    d: "M268.257,126.933H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -126.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2961-2",
    "data-name": "Group 2961",
    transform: "translate(0 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105-2",
    "data-name": "Rectangle 105",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265-2",
    "data-name": "Path 265",
    d: "M260.845,130.254H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2962-2",
    "data-name": "Group 2962",
    transform: "translate(5.241 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106-2",
    "data-name": "Rectangle 106",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266-2",
    "data-name": "Path 266",
    d: "M264.551,130.254H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2963-2",
    "data-name": "Group 2963",
    transform: "translate(10.483 32.878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107-2",
    "data-name": "Rectangle 107",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267-2",
    "data-name": "Path 267",
    d: "M268.257,130.254H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -130.254)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2964-2",
    "data-name": "Group 2964",
    transform: "translate(0 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108-2",
    "data-name": "Rectangle 108",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268-2",
    "data-name": "Path 268",
    d: "M260.845,133.576H258.49v2.576h2.355v-2.576Z",
    transform: "translate(-258.49 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2965-2",
    "data-name": "Group 2965",
    transform: "translate(5.241 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109-2",
    "data-name": "Rectangle 109",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269-2",
    "data-name": "Path 269",
    d: "M264.551,133.576H262.2v2.576h2.355v-2.576Z",
    transform: "translate(-262.196 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2966-2",
    "data-name": "Group 2966",
    transform: "translate(10.483 37.575)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110-2",
    "data-name": "Rectangle 110",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270-2",
    "data-name": "Path 270",
    d: "M268.257,133.576H265.9v2.576h2.355v-2.576Z",
    transform: "translate(-265.902 -133.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2967-2",
    "data-name": "Group 2967",
    transform: "translate(0 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271-2",
    "data-name": "Path 271",
    d: "M260.845,136.9H258.49v2.576h2.355V136.9Z",
    transform: "translate(-258.49 -136.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2968-2",
    "data-name": "Group 2968",
    transform: "translate(5.241 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112-2",
    "data-name": "Rectangle 112",
    width: 0.94,
    height: 1.162,
    transform: "translate(0.708 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272-2",
    "data-name": "Path 272",
    d: "M264.551,136.9H262.2v2.576h2.355V136.9Z",
    transform: "translate(-262.196 -136.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2969-2",
    "data-name": "Group 2969",
    transform: "translate(10.483 42.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113-2",
    "data-name": "Rectangle 113",
    width: 0.941,
    height: 1.162,
    transform: "translate(0.707 0.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273-2",
    "data-name": "Path 273",
    d: "M268.257,136.9H265.9v2.576h2.355V136.9Z",
    transform: "translate(-265.902 -136.897)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3094",
    "data-name": "Group 3094",
    transform: "translate(153.487 138.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304-2",
    "data-name": "Path 304",
    d: "M285.716,117.381H264.5v4.04h1.347v35.649h18.855V121.421h1.01Z",
    transform: "translate(-264.505 -117.381)",
    fill: "#15cdca",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3027-2",
    "data-name": "Group 3027",
    transform: "translate(5.345 6.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3009-2",
    "data-name": "Group 3009"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142-2",
    "data-name": "Rectangle 142",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305-2",
    "data-name": "Path 305",
    d: "M270.549,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-268.284 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3010-2",
    "data-name": "Group 3010",
    transform: "translate(4.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143-2",
    "data-name": "Rectangle 143",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306-2",
    "data-name": "Path 306",
    d: "M273.682,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-271.417 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3011-2",
    "data-name": "Group 3011",
    transform: "translate(8.863)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144-2",
    "data-name": "Rectangle 144",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307-2",
    "data-name": "Path 307",
    d: "M276.815,121.64h-2.265V123.9h2.265V121.64Z",
    transform: "translate(-274.551 -121.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3012-2",
    "data-name": "Group 3012",
    transform: "translate(0 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145-2",
    "data-name": "Rectangle 145",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308-2",
    "data-name": "Path 308",
    d: "M270.549,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3013-2",
    "data-name": "Group 3013",
    transform: "translate(4.431 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146-2",
    "data-name": "Rectangle 146",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309-2",
    "data-name": "Path 309",
    d: "M273.682,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3014-2",
    "data-name": "Group 3014",
    transform: "translate(8.863 4.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147-2",
    "data-name": "Rectangle 147",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310-2",
    "data-name": "Path 310",
    d: "M276.815,124.575h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -124.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3015-2",
    "data-name": "Group 3015",
    transform: "translate(0 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148-2",
    "data-name": "Rectangle 148",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311-2",
    "data-name": "Path 311",
    d: "M270.549,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-268.284 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3016-2",
    "data-name": "Group 3016",
    transform: "translate(4.431 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149-2",
    "data-name": "Rectangle 149",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312-2",
    "data-name": "Path 312",
    d: "M273.682,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-271.417 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3017-2",
    "data-name": "Group 3017",
    transform: "translate(8.863 8.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150-2",
    "data-name": "Rectangle 150",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313-2",
    "data-name": "Path 313",
    d: "M276.815,127.51h-2.265v2.265h2.265V127.51Z",
    transform: "translate(-274.551 -127.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3018-2",
    "data-name": "Group 3018",
    transform: "translate(0 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151-2",
    "data-name": "Rectangle 151",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314-2",
    "data-name": "Path 314",
    d: "M270.549,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3019-2",
    "data-name": "Group 3019",
    transform: "translate(4.431 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152-2",
    "data-name": "Rectangle 152",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315-2",
    "data-name": "Path 315",
    d: "M273.682,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3020-2",
    "data-name": "Group 3020",
    transform: "translate(8.863 12.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153-2",
    "data-name": "Rectangle 153",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-2",
    "data-name": "Path 316",
    d: "M276.815,130.445h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -130.445)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3021-2",
    "data-name": "Group 3021",
    transform: "translate(0 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154-2",
    "data-name": "Rectangle 154",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317-2",
    "data-name": "Path 317",
    d: "M270.549,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-268.284 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3022-2",
    "data-name": "Group 3022",
    transform: "translate(4.431 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155-2",
    "data-name": "Rectangle 155",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318-2",
    "data-name": "Path 318",
    d: "M273.682,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-271.417 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3023-2",
    "data-name": "Group 3023",
    transform: "translate(8.863 16.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156-2",
    "data-name": "Rectangle 156",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2",
    "data-name": "Path 319",
    d: "M276.815,133.38h-2.265v2.265h2.265V133.38Z",
    transform: "translate(-274.551 -133.38)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3024-2",
    "data-name": "Group 3024",
    transform: "translate(0 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157-2",
    "data-name": "Rectangle 157",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2",
    "data-name": "Path 320",
    d: "M270.549,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-268.284 -136.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3025-2",
    "data-name": "Group 3025",
    transform: "translate(4.431 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158-2",
    "data-name": "Rectangle 158",
    width: 0.923,
    height: 0.923,
    transform: "translate(0.671 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2",
    "data-name": "Path 321",
    d: "M273.682,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-271.417 -136.315)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3026-2",
    "data-name": "Group 3026",
    transform: "translate(8.863 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159-2",
    "data-name": "Rectangle 159",
    width: 0.921,
    height: 0.923,
    transform: "translate(0.672 0.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322-2",
    "data-name": "Path 322",
    d: "M276.815,136.315h-2.265v2.265h2.265v-2.265Z",
    transform: "translate(-274.551 -136.315)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTop);
export default __webpack_public_path__ + "static/media/img_top.7e17f9c3aa24dd725b10038432f7a087.svg";
export { ForwardRef as ReactComponent };